module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_m_melanistic.1995fd94.png";